// Squiddi brand assets. The purple wordmark comes from the official
// `squiddi logo intero.pdf` — rasterised at 300 DPI and cropped tight.
// Il polipo resta SOLO come favicon (scelta dell'utente): non va usato
// nell'header, nell'AI o negli stati vuoti.
export const LOGO = "/logo/squiddi-purple.png";
export const LOGO_WHITE = "/logo/squiddi-white.png";
